import { render, staticRenderFns } from "./ReportManagementPage.vue?vue&type=template&id=5793446e"
import script from "./ReportManagementPage.ts?vue&type=script&lang=ts&external"
export * from "./ReportManagementPage.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5793446e')) {
      api.createRecord('5793446e', component.options)
    } else {
      api.reload('5793446e', component.options)
    }
    module.hot.accept("./ReportManagementPage.vue?vue&type=template&id=5793446e", function () {
      api.rerender('5793446e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/report_management/reportManagementPage/ReportManagementPage.vue"
export default component.exports